export default function MobileTerms() {
  return (
    <div className="mobile-terms">
  <h1 className="mobile-terms__main-heading">Mobile Terms of Service</h1>
  <h3 className="mobile-terms__sub-heading">Last updated: October 7, 2025</h3>

  <p className="mobile-terms__description">
    The Amplify Loyalty mobile message service (the “Service”) is operated by Amplify Loyalty (“Amplify Loyalty”, “we”, or “us”).
    Your use of the Service constitutes your agreement to these Mobile Terms of Service (“Mobile Terms”).
    We may modify or cancel the Service or any of its features at any time without notice.
    To the extent permitted by applicable law, we may also modify these Mobile Terms,
    and your continued use of the Service following the effective date of any such changes
    shall constitute your acceptance of those changes.
  </p>

  <h2 className="mobile-terms__sub-heading">1. Consent to Receive Messages</h2>
  <p className="mobile-terms__description">
    By consenting to Amplify Loyalty’s SMS/text messaging service, you agree to receive recurring SMS/text messages from and on behalf of Amplify Loyalty
    through your wireless provider to the mobile number you provided, even if your number is registered on any state or federal Do Not Call list.
    Text messages may be sent using an automatic telephone dialing system or other technology.
    Promotional messages may include promotions, specials, and other marketing offers (e.g., cart reminders).
  </p>

  <h2 className="mobile-terms__sub-heading">2. Voluntary Participation</h2>
  <p className="mobile-terms__description">
    You understand that you do not have to sign up for this program in order to make any purchases, and your consent is not a condition of any purchase.
    Your participation in this program is completely voluntary.
  </p>

  <h2 className="mobile-terms__sub-heading">3. Fees and Message Frequency</h2>
  <p className="mobile-terms__description">
    We do not charge for the Service, but you are responsible for all charges and fees associated with text messaging imposed by your wireless provider.
    Message frequency varies. Message and data rates may apply. Check your mobile plan and contact your wireless provider for details.
  </p>

  <h2 className="mobile-terms__sub-heading">4. How to Opt Out</h2>
  <p className="mobile-terms__description">
    You may opt out of the Service at any time by texting the single keyword command <strong>STOP</strong> to <strong>+1 (844) 449-3899 </strong>
    or by clicking the unsubscribe link (where available) in any text message to cancel.
    You will receive a one-time opt-out confirmation text message.
    No further messages will be sent to your mobile device, unless initiated by you.
    If you have subscribed to other Amplify Loyalty mobile message programs, you will need to opt out separately from each.
  </p>

  <h2 className="mobile-terms__sub-heading">5. Support and Contact</h2>
  <p className="mobile-terms__description">
    For Service support or assistance, text <strong>HELP</strong> to <strong>+1 (844) 449-3899</strong> or email
    <a href="mailto:trevor@amplifyloyalty.com"> trevor@amplifyloyalty.com</a>.
  </p>

  <h2 className="mobile-terms__sub-heading">6. Changes to Numbers or Short Codes</h2>
  <p className="mobile-terms__description">
    We may change any short code or telephone number we use to operate the Service at any time and will notify you of such changes.
    You acknowledge that messages, including STOP or HELP requests, sent to a changed number may not be received,
    and we are not responsible for honoring such requests.
  </p>

  <h2 className="mobile-terms__sub-heading">7. Carrier Liability</h2>
  <p className="mobile-terms__description">
    The wireless carriers supported by the Service are not liable for delayed or undelivered messages.
    You agree to provide us with a valid mobile number. If you get a new number, you must re-enroll with your new mobile number.
  </p>

  <h2 className="mobile-terms__sub-heading">8. Disclaimer of Liability</h2>
  <p className="mobile-terms__description">
    To the extent permitted by applicable law, we are not liable for failed, delayed, or misdirected delivery of any information sent through the Service,
    any errors in such information, or any actions you may or may not take in reliance on the information or Service.
  </p>

  <h2 className="mobile-terms__sub-heading">9. Privacy</h2>
  <p className="mobile-terms__description">
    We respect your privacy. To learn how we collect and use personal information, please see 
    our <a href="/privacy-policy">Privacy Policy</a>.
  </p>
</div>

  );
}